<template>
    <div class="product-matcher">
        <div class="search-area">
            <el-input clearable placeholder="请输入查询内容" v-model="searchStr" style="width: 360px;margin-top: 3px"
            @input="searchStr = searchStr.trim()">
                <el-select v-model="searchType" slot="prepend" style="width: 100px" clearable>
                    <el-option label="SKU" value="sku"></el-option>
                    <el-option label="名称" value="name"></el-option>
                    <el-option label="型号" value="model"></el-option>
                    <el-option label="品牌" value="brand"></el-option>
                </el-select>
            </el-input>
            <el-button type="primary" @click="searchProducts">搜索</el-button>
        </div>
        <div class="product-table">
            <el-table :data="productList" border style="width: 100%" v-loading="loading"
                @selection-change="handleSelectionChange" max-height="500">
                <el-table-column label="图片" width="100" align="center">
                    <template slot-scope="scope">
                        <div class="product-image">
                            <el-image 
                                :src="scope.row.imagesJson.mainImages.length > 0 ? scope.row.imagesJson.mainImages[0] : ''" 
                                :preview-src-list="scope.row.imagesJson.mainImages">
                            </el-image>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="名称" prop="name">
                </el-table-column>
                <el-table-column label="SKU" prop="sku">
                </el-table-column>
                <el-table-column label="型号" prop="model">
                </el-table-column>
                <el-table-column label="品牌" prop="brand">
                </el-table-column>
                <el-table-column label="操作" width="80" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="matchProduct(scope.row)">
                            配对
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="pagination-area">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 50]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { ajaxPost, Baseurl } from "@/api/api/api";
export default {
    name: 'ProductMatcher',
    data() {
        return {
            searchKeyword: '',
            loading: false,
            productList: [],
            selectedProducts: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            searchType: 'sku',
            searchStr: ''
        }
    },
    props: {
        productData: {
            type: Object,
            default: () => {}
        }
    },
    computed:{
        userInfo(){
            return JSON.parse(localStorage.getItem('role'))
        }
    },
    created() {
        this.loadProductList();
    },
    methods: {
        // 加载产品列表
        loadProductList() {
            this.loading = true;
            const params = {
                page: this.currentPage,
                size: this.pageSize,
                "status": 1,
                "companyId": this.userInfo.company_id,
            }
            if(this.searchType){
                params.searchType = this.searchType;
            }
            if(this.searchStr){
                params.searchStr = this.searchStr;
            }
            ajaxPost(Baseurl + "productController/selectNotPairedChildProductLibraryPage", params).then(res => {
                console.log(res);
                if(res.data.code === 200){
                    this.productList = res.data.data.list;
                    this.total = res.data.data.total;
                }
                this.loading = false;
            })
        },

        // 搜索产品
        searchProducts() {
            this.currentPage = 1
            this.loadProductList()
        },

        // 处理选择变化
        handleSelectionChange(selection) {
            this.selectedProducts = selection
        },

        // 配对单个产品
        matchProduct(product) {
            this.$emit('match', product)
        },

        // 分页处理
        handleSizeChange(size) {
            this.pageSize = size
            this.loadProductList()
        },

        handleCurrentChange(page) {
            this.currentPage = page
            this.loadProductList()
        }
    }
}
</script>

<style lang="scss" scoped>
.product-matcher {
    padding: 20px;

    .search-area {
        display: flex;
        margin-bottom: 20px;
        .search-input {
            width: 300px;
            margin-right: 10px;
        }
    }

    .product-table {
        margin-bottom: 20px;
        .product-image {
            width: 50px;
            height: 50px;
            margin: 0 auto;
            overflow: hidden;
            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }
    }

    .pagination-area {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .cancel-btn {
            margin-left: 20px;
        }
    }
}
</style>